import { getDoc, getFirestore, doc } from "firebase/firestore";
import employeeConverter from "../converters/employeeConverter";
import { Employee } from "../types/Employee";

export const queryEmployee = async (idNumber: string) => {
  const db = getFirestore();
  return await getDoc(doc(db, `Employees/${idNumber}`).withConverter<Employee>(employeeConverter)).then((doc) => {
    if (doc.exists()) {
      return doc.data();
    }
  });
};